import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import {persistStore, autoRehydrate} from 'redux-persist'
import rootReducer from '../reducers/reducers'

export default (initialState) => {
  const middlewares = [thunk]
  const enhancer = compose(
    applyMiddleware(...middlewares),
    autoRehydrate({ config: { log: true } })
  )
  const store = createStore(rootReducer, initialState, enhancer)
  persistStore(store, { blacklist: ['online', 'lasted'] })
  return store
}


// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js